import { createSelector } from "@reduxjs/toolkit";
export const selectIsZeroValueOrder = (isFreeTrial) => createSelector([
    (state) => state.freeTrialCart.isZeroValueOrder,
    (state) => state.cart.isZeroValueOrder,
], (freeTrialZeroValueOrder, cartZeroValueOrder) => (isFreeTrial ? freeTrialZeroValueOrder : cartZeroValueOrder));
//# sourceMappingURL=selectIsZeroValueOrder.js.map